var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.971 3.972a.667.667 0 00-.942-.943L8 7.057 3.971 3.03a.667.667 0 10-.942.943L7.057 8 3.03 12.03a.667.667 0 10.942.943L8 8.943l4.029 4.029a.667.667 0 00.942-.943L8.943 8l4.028-4.028z"
  })));
}

export default SvgCross;